import { UStyles } from "@/app/utils/UStyles";
import { coverBars } from "./BlogCover.logic";
import styles from "./BlogCover.module.css";

type Props = {
  seed: number;
};

export default function BlogCoverWave(props: Props) {
  const { seed } = props;

  return (
    <span className={styles.wave}>
      {coverBars(seed).map((bar) => (
        <span
          key={bar.id}
          className={UStyles.classNames(styles.bar, bar.isPlayed ? styles.barPlayed : "")}
          style={{ height: bar.height }}
        />
      ))}
    </span>
  );
}
